import React from 'react';
import { TopicStyles } from './mixins/mixins';
import {
	FontValues,
	ModeValues,
	OpacityValues,
	ViewValues
} from './mixins/optionsValues';
import { StyleDropdownMenu } from './components/common';

export const AppearanceStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleDropdownMenu
				key="mode"
				name={'Mode'}
				options={[
					{ name: 'Light', value: ModeValues.LIGHT },
					{ name: 'Dark', value: ModeValues.DARK },
					{ name: 'System', value: ModeValues.SYSTEM }
				]}
				optionState={style.appearanceStyle.mode}
				handleChange={(value: any) => {
					setStyle({
						...style,
						appearanceStyle: { ...style.appearanceStyle, ['mode']: value }
					});
				}}
			/>
			<StyleDropdownMenu
				key="opacity"
				name={'Opacity'}
				options={[
					{ name: 'Opaque', value: OpacityValues.OPAQUE },
					{ name: 'Translucent', value: OpacityValues.TRANSLUCENT },
					{ name: 'Transparent', value: OpacityValues.TRANSPARENT }
				]}
				optionState={style.appearanceStyle.opacity}
				handleChange={(value: any) => {
					setStyle({
						...style,
						appearanceStyle: { ...style.appearanceStyle, ['opacity']: value }
					});
				}}
			/>

			<StyleDropdownMenu
				key="view"
				name={'View'}
				options={[
					{ name: 'Expanded', value: ViewValues.EXPANDED },
					{ name: 'Contracted', value: ViewValues.CONTRACTED }
				]}
				optionState={style.appearanceStyle.view}
				handleChange={(value: any) => {
					setStyle({
						...style,
						appearanceStyle: { ...style.appearanceStyle, ['view']: value }
					});
				}}
			/>

			<StyleDropdownMenu
				key="font"
				name={'Font'}
				options={[
					{ name: 'Standard', value: FontValues.STANDARD },
					{ name: 'Classic', value: FontValues.CLASSIC },
					{ name: 'Artistic', value: FontValues.ARTISTIC }
				]}
				optionState={style.appearanceStyle.font}
				handleChange={(value: any) => {
					setStyle({
						...style,
						appearanceStyle: { ...style.appearanceStyle, ['font']: value }
					});
				}}
			/>
		</div>
	);
};
